<template>
	<div class="aboutUs-container">
		<div class="tabs mainCont">
			<div class="item " :class="activeName==1?'active':''" @click="handleClick('1')">企业文化</div>
			<div class="item " :class="activeName==2?'active':''" @click="handleClick('2')">发展历史</div>
			<div class="item " :class="activeName==3?'active':''" @click="handleClick('3')">联系我们</div>
			<div class="item " :class="activeName==4?'active':''" @click="handleClick('4')">公司简介</div>
			<div class="item " :class="activeName==5?'active':''" @click="handleClick('5')">加入我们</div>
		</div>
		<first-view v-if="activeName==1" ref="firstViewRef"></first-view>
		<second-view v-if="activeName==2" ref="secondViewRef"></second-view>
		<third-view v-if="activeName==3" ref="thirdViewRef"></third-view>
		<fourth-view v-if="activeName==4" ref="fourthViewRef"></fourth-view>
		<fifth-view v-if="activeName==5" ref="fifthViewRef"></fifth-view>
	</div>
</template>
<script>
	import firstView from './components/firstView';
	import secondView from './components/secondView';
	import thirdView from './components/thirdView';
	import fourthView from './components/fourthView';
	import fifthView from './components/fifthView';
	
	
	
	export default {
		name: 'aboutUs',
		components: {
			firstView,secondView,thirdView,fourthView,fifthView
		},
		data() {
			return {
				activeName: '1',

			};
		},
		mounted() {
		},
		methods: {
			handleClick(type) {
				this.activeName = type;
			}
		},
	};
</script>
<style lang="scss" scoped>
.aboutUs-container{background-color: #fff;padding-top: 30px;
	.tabs{border-bottom: 1px solid #EDEEF1;display: flex;align-items: center;
		.item{flex: 1;position: relative;color: #1F263F;font-size: 18px;text-align: center;transition: all .3s;padding: 20px 0;cursor: pointer;
			&.active{color: #2F78FF;font-weight: bold;
				&::after{content: '';width: 37px;height: 2px;background: #2F78FF;position: absolute;left: 0;right: 0;bottom: 0;margin: auto;}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/index.vue